import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { Label, Input } from 'reactstrap';

import './input.scss';

export const InputComponent = ({ labelText = null, startAdornment = null, ...restInputProps }) => {
  const id = useId();
  return (
    <Label htmlFor={id} className="lease-input-filter form-control rounded-8 px-1 py-0_5 mb-0">
      {labelText && <span className="size-12 text-cool-gray-30">{labelText}</span>}
      <span className="d-flex align-items-baseline w-100">
        {startAdornment && startAdornment}
        <Input {...restInputProps} id={id} className="size-16 border-0 p-0" />
      </span>
    </Label>
  );
};

InputComponent.propTypes = {
  labelText: PropTypes.string,
  startAdornment: PropTypes.element,
};
